export const configFilename = "config.json";
